import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FiTwitter, FiLinkedin, FiMail, FiPhone, FiMapPin } from 'react-icons/fi';
import Logo from './Logo';
import './Footer.css';

const Footer = () => {
  const [showFixedButtons, setShowFixedButtons] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      // Show buttons when scrolled down more than 300px
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setShowFixedButtons(scrollTop > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Scroll to top when location changes (for fixed button navigation)
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const handleNavigation = (path) => {
    // Navigate to the new page
    navigate(path);
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section">
            <div className="footer-logo">
              <Logo />
            </div>
            <p className="footer-description">
              AI-powered observability platform for logs and infrastructure. Monitor, analyze, and optimize your systems with intelligent insights.
            </p>
            <div className="social-links">
              <a href="https://x.com/LogCrest_AI" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <FiTwitter />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FiLinkedin />
              </a>
            </div>
          </div>

          {/* Product Links */}
          <div className="footer-section">
            <h4>Product</h4>
            <ul className="footer-links">
              <li><Link to="/observability-platform">Observability Platform</Link></li>
              <li><Link to="/log-management">Log Management</Link></li>
              <li><Link to="/ai-monitoring">AI Monitoring</Link></li>
              <li><Link to="/cloud-monitoring">Cloud Monitoring</Link></li>
              <li><Link to="/devops-observability">DevOps Observability</Link></li>
              <li><Link to="/agent-sre">AgentSRE</Link></li>
              <li><Link to="/ai-alerting">AI Alerting</Link></li>
              <li><Link to="/security">Security</Link></li>
              <li><Link to="/ai-ops">AI Ops</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
            </ul>
          </div>
          
          {/* Resources Links */}
          <div className="footer-section">
            <h4>Resources</h4>
            <ul className="footer-links">
              <li><Link to="/logcrest-vs-datadog">vs Datadog</Link></li>
              <li><Link to="/logcrest-vs-splunk">vs Splunk</Link></li>
              <li><Link to="/logcrest-vs-newrelic">vs New Relic</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/faqs">FAQs</Link></li>
            </ul>
          </div>

          {/* Company Links */}
          <div className="footer-section">
            <h4>Company</h4>
            <ul className="footer-links">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/careers">Careers</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4>Contact</h4>
            <div className="contact-info">
              <div className="contact-item">
                <FiMail />
                <span>hello@logcrest.com</span>
              </div>
              <div className="contact-item">
                <FiPhone />
                <span>+91 6360765326</span>
              </div>
              <div className="contact-item">
                <FiMapPin />
                <span>Bangalore, IN</span>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2026 Nth Unicorn. All rights reserved.</p>
            <div className="footer-bottom-links">
              <Link to="/privacy">Privacy</Link>
              <Link to="/terms">Terms</Link>
              <Link to="/faqs">FAQs</Link>
            </div>
          </div>
        </div>
      </div>
      
      {/* Fixed Action Buttons */}
      {showFixedButtons && (
        <div className="fixed-action-buttons">
          <button 
            onClick={() => handleNavigation('/pricing')} 
            className="fixed-btn contact-sales-btn"
          >
            Contact Sales
          </button>
          <button 
            onClick={() => handleNavigation('/demo')} 
            className="fixed-btn schedule-demo-btn"
          >
            Schedule Demo
          </button>
        </div>
      )}
    </footer>
  );
};

export default Footer;
